import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    tabPanelContent: {
      width: '100%',
      minWidth: 750,
    },
  });
